export default __webpack_public_path__ + "static/shipmentManagementVp2-3-c668ac63d59ffe1349c22ca5279aa3fd.png";